angular.module('app.services').factory('practiceAreaService', [
  function practiceAreaService() {
    let instance = {
      selectPracticeArea: (practiceAreasList, selectedValue, event) => {
        const checked = event.target.checked
        if (selectedValue.parentId) {
          let parentPracticeArea = getPracticeAreaById(
            practiceAreasList,
            selectedValue.parentId
          )
          if (!parentPracticeArea) {
            parentPracticeArea = practiceAreasList
              .map(practiceArea => {
                return practiceArea.children
                  ? getPracticeAreaById(
                      practiceArea.children,
                      selectedValue.parentId
                    )
                  : undefined
              })
              .find(practiceArea => practiceArea)
          }

          parentPracticeArea.isSelected =
            checked === false
              ? getSiblingPracticeAreaById(
                  parentPracticeArea.children,
                  selectedValue.id
                )
              : checked

          if (parentPracticeArea.parentId) {
            const grandParentPracticeArea = getPracticeAreaById(
              practiceAreasList,
              parentPracticeArea.parentId
            )
            grandParentPracticeArea.isSelected =
              checked === false
                ? getSiblingPracticeAreaById(
                    grandParentPracticeArea.children,
                    selectedValue.id
                  )
                : checked
          }
        }

        if (selectedValue.children) {
          selectedValue.children.map(child => {
            if (child.children) {
              child.children.map(subChild => {
                subChild.isSelected = checked
                return subChild
              })
            }

            child.isSelected = checked
            return child
          })
        }

        selectedValue.isSelected = checked
      },
      setIsSelectedChildrenPracticeArea: (
        allPracticeAreasList,
        selectedPractice
      ) => {
        allPracticeAreasList.forEach(practiceArea => {
          if (practiceArea.isSelected === true && practiceArea.children) {
            practiceArea.children.forEach(child => {
              if (child.isSelected === true && child.children) {
                const subChildren = child.children.filter(
                  subChild => subChild.isSelected === true
                )
                if (subChildren.length > 0) {
                  subChildren.forEach(subChild => {
                    selectedPractice.push(subChild)
                  })
                }
              } else if (child.isSelected === true) {
                selectedPractice.push(child)
              }
            })
          } else if (practiceArea.isSelected === true) {
            selectedPractice.push(practiceArea)
          }
        })
        return selectedPractice
      },

      initialize: (selectedPractices, allPracticeAreasList, checked) => {
        instance.clearSelection(allPracticeAreasList, checked)
        selectedPractices.forEach(selectedValue => {
          assignSelectedPracticeAreaHierarchy(
            selectedValue,
            true,
            allPracticeAreasList,
            instance
          )
        })
      },
      makeCandidatePracticeAreasHierarchy: (
        candidateCategories,
        allPracticeAreas
      ) => {
        let practiceAreasWithParent = []
        const candidatePracticeAreas = new Set(
          candidateCategories &&
            candidateCategories
              .find(({id}) => id === 1)
              .specialties.map(({id}) => id)
        )

        const candidatePracticeAreasFromList = allPracticeAreas.filter(({id}) =>
          candidatePracticeAreas.has(id)
        )
        candidatePracticeAreasFromList.forEach(practiceArea => {
          assignParentsToPracticeAreas(
            practiceArea,
            allPracticeAreas,
            practiceAreasWithParent
          )
        })
        practiceAreasWithParent = practiceAreasWithParent
          .filter((v, index, a) => a.findIndex(t => t.id === v.id) === index)
          .sort((a, b) => (a.id > b.id ? 1 : -1))

        instance.initialize([], practiceAreasWithParent, true)
        return practiceAreasWithParent
      },
      clearSelection: (allPracticeAreasList, selection) => {
        instance.selectPracticeAreas(allPracticeAreasList, selection)
      },
      selectPracticeAreas: (allPracticeAreasList, selection) => {
        allPracticeAreasList.forEach(practice => {
          practice.isSelected = selection
          if (practice.children && practice.children.length > 0)
            instance.selectPracticeAreas(practice.children, selection)
        })
      },
      selectOrDeselectAllPractices: (allPracticeAreasList, selection) => {
        instance.selectPracticeAreas(allPracticeAreasList, selection)
      },
      onlyChildrenPractices: (allPracticeAreasList, onlyChildrenPractices) => {
        allPracticeAreasList.forEach(practiceArea => {
          if (practiceArea.children) {
            practiceArea.children.forEach(child => {
              if (child.children) {
                const subChildren = child.children.filter(
                  subChild => subChild.parentId !== null
                )
                if (subChildren.length > 0) {
                  subChildren.forEach(subChild => {
                    onlyChildrenPractices.push(subChild)
                  })
                }
              } else if (child.parentId !== null)
                onlyChildrenPractices.push(child)
            })
          } else if (practiceArea.parentId === null && !practiceArea.children) {
            onlyChildrenPractices.push(practiceArea)
          }
        })
        return onlyChildrenPractices
      },
    }

    return instance
  },
])

/** This method will assign isSelected checked and unchecked of selected Practice area  in hierarchial way.
 * @param  {} selectedValue
 * @param  {} checked
 * @param  {} vm
 */
const assignSelectedPracticeAreaHierarchy = (
  selectedValue,
  checked,
  allPracticeAreasList,
  instance
) => {
  if (selectedValue.parentId) {
    let parentPracticeArea = allPracticeAreasList.find(
      ({id}) => id === selectedValue.parentId
    )

    if (!parentPracticeArea) {
      parentPracticeArea = allPracticeAreasList
        .map(practiceArea => {
          return practiceArea.children
            ? practiceArea.children.find(
                ({id}) => id === selectedValue.parentId
              )
            : undefined
        })
        .find(practiceArea => practiceArea)
    }

    parentPracticeArea.isSelected = checked
    if (parentPracticeArea.parentId) {
      allPracticeAreasList.find(
        ({id}) => id === parentPracticeArea.parentId
      ).isSelected = checked
    }

    if (parentPracticeArea.children) {
      parentPracticeArea.children.find(
        ({id}) => id === selectedValue.id
      ).isSelected = checked
    }
  } else {
    const practiceArea = allPracticeAreasList.filter(
      ({id}) => id === selectedValue.id
    )
    instance.selectPracticeAreas(practiceArea, checked)
  }
}

/** This method will find sibling of Practice Area
 * @param  {} list either practice area or children of practice area
 * @param  {} id id
 */
const getSiblingPracticeAreaById = (list, id) => {
  return list.some(sibling => sibling.isSelected === true && sibling.id !== id)
}

/** This method will find and return record of PracticeArea by id
 * @param  {} list  either PracticeAreas or PracticeArea children
 * @param  {} id id
 */
const getPracticeAreaById = (list, id) => {
  return list.find(row => row.id === id)
}

const assignParentsToPracticeAreas = (
  practiceArea,
  allPracticeAreas,
  practiceAreasWithParent
) => {
  if (practiceArea.parentId === null) {
    practiceAreasWithParent.push(practiceArea)
    return
  }

  if (
    practiceAreasWithParent.findIndex(({id}) => practiceArea.parentId === id) >=
    0
  ) {
    const parentId = practiceAreasWithParent.findIndex(
      ({id}) => practiceArea.parentId === id
    )
    const parent = practiceAreasWithParent[parentId]

    parent.children = [...parent.children, practiceArea]
    practiceArea = Object.assign(parent)
  } else {
    const parentId = allPracticeAreas.findIndex(
      ({id}) => practiceArea.parentId === id
    )
    const parent = allPracticeAreas[parentId]

    parent.children = [practiceArea]
    practiceArea = Object.assign(parent)
  }

  assignParentsToPracticeAreas(
    practiceArea,
    allPracticeAreas,
    practiceAreasWithParent
  )
}



// WEBPACK FOOTER //
// ./scripts/shared/directives/practice-area/practice-area.service.js